<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />
    <b-row>
      <router-link :to="'/trackingShippingCompany/cargo/rotogram/create'">
        <b-button size="sm">
          {{ $t(`tracking.cargo.createRotogram`) }}
        </b-button>
      </router-link>

      <b-table
        ref="rotogramaTable"
        :busy.sync="isBusy"
        :items="tableProvider"
        :fields="fields"
        :filter="filter"
        :filter-debounce="600"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        striped
        hover
      >
        <template #thead-top>
          <b-tr style="">
            <b-th></b-th>
            <b-th>
              <b-form-input
                :placeholder="$t('geral.filter.filterById')"
                v-model="filter.id"
              />
            </b-th>
            <b-th>
              <b-form-input
                :placeholder="$t('geral.filter.filterByOrigin')"
                v-model="filter.cidadeOrigem"
              />
            </b-th>
            <b-th>
              <b-form-input
                :placeholder="$t('geral.filter.filterByState')"
                v-model="filter.siglaOrigem"
              />
            </b-th>
            <b-th>
              <b-form-input
                :placeholder="$t('geral.filter.filterByDestiny')"
                v-model="filter.cidadeDestino"
              />
            </b-th>
            <b-th>
              <b-form-input
                :placeholder="$t('geral.filter.filterByState')"
                v-model="filter.siglaDestino"
              />
            </b-th>

            <b-th>
              <b-form-input type="date" v-model="filter.dateUpdateAt" />
            </b-th>

            <b-th>
              <b-form-select
                v-model="filter.active"
                :options="optionsBoolean"
              />
            </b-th>
          </b-tr>
        </template>

        <template #cell(actions)="data">
          <router-link
            :to="'/trackingShippingCompany/cargo/rotogram/edit/' + data.item.id"
          >
            <b-button size="sm">{{ $t("checklist.form.edit") }}</b-button>
          </router-link>

          <b-button
            v-if="data.item.active == true"
            style="margin-left: 5px"
            size="sm"
            @click="deletar(data.item.id)"
            >{{ $t("geral.disable") }}
          </b-button>

          <b-button
            v-if="data.item.active == false"
            style="margin-left: 5px"
            size="sm"
            @click="Ativar(data.item.id)"
          >
            {{ "Ativar" }}
          </b-button>
        </template>
      </b-table>
    </b-row>

    <b-row>
      <b-col sm="5" md="5" lg="5" class="mt-1">
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="tableRowCount"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        />
      </b-col>

      <b-col sm="4" md="4" lg="4" class="mt-2">
        <label for="perPageSelect">
          Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de
          {{ tableRowCount }}
        </label>
      </b-col>

      <b-col sm="3" md="3" lg="3">
        <b-form-group
          label-cols-md="6"
          label="Por página"
          label-align-md="right"
          label-for="perPageSelect"
        >
          <b-form-select
            class="mt-1"
            v-model="tablePerPage"
            id="perPageSelect"
            size="sm"
            :options="tablePageOptions"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Setor desativado com sucesso"
      },
      tablePerPage: 5,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableRowCount: 0,
      fields: [
        {
          key: "actions",
          label: "",
          tdClass: "actions",
          thStyle: "width: 230px",
        },
        {
          key: "id",
          sortable: true,
          label: this.$t("tracking.table.id"),
          thStyle: "width: 80px",
        },
        {
          key: "cityOriginName",
          sortable: true,
          label: this.$t("tracking.table.origin"),
          thStyle: "width: 240px",
        },
        {
          key: "cityOriginState",
          sortable: true,
          label: this.$t("tracking.table.state"),
          thStyle: "width: 80px",
        },
        {
          key: "cityDestinyName",
          sortable: true,
          label: this.$t("tracking.table.destiny"),
          thStyle: "width: 240px",
        },
        {
          key: "cityDestinyState",
          sortable: true,
          label: this.$t("tracking.table.state"),
          thStyle: "width: 80px",
        },
        {
          key: "updateAt",
          sortable: true,
          label: "Última Atualização",
          thStyle: "width: 180px",
        },
        {
          key: "active",
          sortable: true,
          label: "Ativo",
          thStyle: "width: 110px",
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      optionsBoolean: [
        {
          value: 2,
          text: "Todos",
        },
        { value: 1, text: "Sim" },
        { value: 0, text: "Não" },
      ],
      sortBy: "id",
      sortDesc: false,
      items: [],
      isBusy: false,
      filter: {
        id: "",
        cidadeOrigem: "",
        siglaOrigem: "",
        cidadeDestino: "",
        siglaDestino: "",
        dateUpdateAt: Date,
        active: 1,
      },
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    tableProvider(ctx, callback) {
      this.isBusy = true;

      let apiFilter = {
        perPage: ctx.perPage,
        currentPage: ctx.currentPage,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        id: ctx.filter.id,
        cidadeOrigem: ctx.filter.cidadeOrigem,
        siglaOrigem: ctx.filter.siglaOrigem,
        cidadeDestino: ctx.filter.cidadeDestino,
        siglaDestino: ctx.filter.siglaDestino,
        dateUpdateAt: ctx.filter.dateUpdateAt,
        active: ctx.filter.active,
      };
      this.$api
        .post("/rotograma/list/all", apiFilter)
        .then((response) => {
          this.tableRowCount = response.data.totalItems;
          this.isBusy = false;
          this.items = response.data.items;
          callback(this.items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
              this.isBusy = false;
            });
          } else {
            this.tableIsBusy = false;
            this.tableRowCount = 0;
            this.isBusy = false;
            callback([]);
          }
        });
      return null;
    },
    Ativar(id) {
      this.$api
        .put(`/rotograma/active/${id}`)
        .then((response) => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          } else {
            this.$refs.rotogramaTable.refresh();
            this.$forceUpdate();
          }
        })
       .catch((error) => {
          console.log(error);
          if (error.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            
          }
        });
    },
    deletar(id) {
      this.$api
        .delete(`/rotograma/disable/${id}`)
        .then((response) => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          } else {
            this.$refs.rotogramaTable.refresh();
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            
          }
        });
    },
    voltar() {
      this.$router.go(-1);
    },
    onRowSelected(items) {
      this.tableSelectedItem = items;
      this.$emit("rowSelected", this.tableSelectedItem);
    },
  },
};
</script>